/*
  BKM: 3-månadersplanen läggs i varukorgen som Recharge preset-bundle (22 okt 2026)
  Konfig i layout/theme.liquid: window.BKM_BUNDLES = { "<produkt-handle>": {
      "fromPlans": ["<selling plan-id på burken som ska ersättas>"],
      "bundleHandle": "<bundle-produktens handle>",
      "variantId": "<bundle-variantens id>",
      "sellingPlanId": "<bundle-produktens selling plan-id>" } }
  - Preset-bundles behöver inga line item properties (Recharge lägger till innehållet i ordern efteråt).
  - Bundlen används bara om /products/<bundleHandle>.js svarar och varianten är köpbar med planen.
    Annars: allt som idag (ingen ändring).
  - Temats egen add-to-cart körs som vanligt (låda öppnas av temat); bara själva /cart/add-anropet
    byts ut, via XHR så att andra fetch-wrappers (Shoplift) inte skriver om selling_plan.
  - Pris på 3-månadersraden = bundlens pris (aktiv valuta).
  Test (bara på opublicerat tema): ?bkm_bundle_force=1 kör vägen även om bundlen inte är publicerad,
  ?bkm_bundle_test=<variantId>:<sellingPlanId> byter mål (för att prova hela flödet), ?bkm_debug=1 loggar.
*/
(function () {
  'use strict';
  if (window.__bkmBundleCart) return;
  window.__bkmBundleCart = true;
  var DEBUG = /bkm_debug=1/.test(location.search);
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[BKM-BUNDLE]'].concat([].slice.call(arguments))); }

  var CONF = window.BKM_BUNDLES || {};
  var el = document.querySelector('script[data-product-json]') || document.querySelector('script[id^="ProductJson"]');
  var product = null;
  try { product = el && JSON.parse(el.textContent); } catch (e) {}
  if (!product || !CONF[product.handle]) { log('ingen bundle-konfig för', product && product.handle); return; }
  var cfg = {};
  for (var k in CONF[product.handle]) cfg[k] = CONF[product.handle][k];
  var fromPlans = (cfg.fromPlans || []).map(String);

  var isPreviewTheme = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  var FORCE = isPreviewTheme && /bkm_bundle_force=1/.test(location.search);
  var tm = isPreviewTheme && decodeURIComponent(location.search).match(/bkm_bundle_test=(\d+):(\d+)/);
  if (tm) { cfg.variantId = tm[1]; cfg.sellingPlanId = tm[2]; FORCE = true; log('TESTMÅL', cfg.variantId, cfg.sellingPlanId); }

  var state = { ready: FORCE, priceCents: null };
  window.__bkmBundleState = state;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  // 1) Finns bundlen i butiken och går den att köpa med planen?
  if (cfg.bundleHandle && !tm) {
    fetch(root() + 'products/' + cfg.bundleHandle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(cfg.variantId); })[0];
        if (!v) throw new Error('variant saknas');
        if (v.available === false) throw new Error('slutsåld');
        var a = (v.selling_plan_allocations || []).filter(function (x) { return String(x.selling_plan_id) === String(cfg.sellingPlanId); })[0];
        if (!a) throw new Error('planen saknas på bundlen');
        state.ready = true;
        state.priceCents = a.per_delivery_price || a.price || v.price;
        log('bundle redo', cfg.bundleHandle, state.priceCents);
        tick();
      })
      .catch(function (e) { log('bundle ej tillgänglig -> oförändrat beteende:', String(e)); if (!FORCE) state.ready = false; });
  }

  function deepQueryAll(r, sel, out) {
    out = out || [];
    if (!r) return out;
    try { r.querySelectorAll(sel).forEach(function (n) { out.push(n); }); } catch (e) {}
    try { r.querySelectorAll('*').forEach(function (n) { if (n.shadowRoot) deepQueryAll(n.shadowRoot, sel, out); }); } catch (e) {}
    return out;
  }
  function productForms() {
    return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) {
      var pid = f.querySelector('input[name="product-id"]');
      return !pid || String(pid.value) === String(product.id);
    });
  }
  function selectedPlan(form) {
    var h = form && form.querySelector('input[type="hidden"][name="selling_plan"]');
    if (h && h.value) return String(h.value);
    var c = form && form.querySelector('input[name="selling_plan"]:checked');
    if (c && c.value) return String(c.value);
    var w = deepQueryAll(document.querySelector('recharge-subscription-widget') && document.querySelector('recharge-subscription-widget').shadowRoot, 'input[type="radio"]:checked')[0];
    return w ? String(w.value || '') : '';
  }

  // 2) Pris på 3-månadersraden = bundlens pris
  function parseMoney(txt) {
    var m = String(txt).match(/\d[\d.,\s\u00a0\u202f']*\d|\d/);
    if (!m) return null;
    var raw = m[0], decSep = null, decimals = 0, dm = raw.match(/([.,])(\d{1,2})$/);
    if (dm) { decSep = dm[1]; decimals = dm[2].length; }
    var intPart = decSep ? raw.slice(0, raw.length - decimals - 1) : raw;
    var th = intPart.match(/[^\d]/);
    return { raw: raw, index: m.index, decSep: decSep, decimals: decimals, thouSep: th ? th[0] : '',
      value: parseFloat(intPart.replace(/[^\d]/g, '') + (decSep ? '.' + dm[2] : '')) };
  }
  function formatLike(p, value) {
    var parts = value.toFixed(p.decimals).split('.'), i = parts[0];
    if (p.thouSep) i = i.replace(/\B(?=(\d{3})+(?!\d))/g, p.thouSep);
    return parts.length > 1 ? i + (p.decSep || '.') + parts[1] : i;
  }
  function tick() {
    if (!state.ready || state.priceCents == null) return;
    var w = document.querySelector('recharge-subscription-widget');
    deepQueryAll(w && w.shadowRoot, 'input[type="radio"]').forEach(function (r) {
      if (fromPlans.indexOf(String(r.value)) === -1) return;
      var row = r.closest('.rc-quantity-upsell-option') || r.closest('label');
      if (!row) return;
      row.setAttribute('data-bkm-bundle', '1'); // lock-skriptet låter raden vara
      var box = row.querySelector('.rc-quantity-upsell-option__header > div:last-child');
      if (!box) return;
      var tw = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null), n, tn = null;
      while ((n = tw.nextNode())) if (/\d/.test(n.nodeValue)) tn = n;
      if (!tn || tn.__bkmBundleWritten === tn.nodeValue) return;
      var p = parseMoney(tn.nodeValue);
      if (!p) return;
      var next = tn.nodeValue.slice(0, p.index) + formatLike(p, state.priceCents / 100) + tn.nodeValue.slice(p.index + p.raw.length);
      if (next !== tn.nodeValue) { log('pris 3-mån', tn.nodeValue, '->', next); tn.nodeValue = next; }
      tn.__bkmBundleWritten = tn.nodeValue;
    });
  }
  setInterval(tick, 400);

  // 3) Byt ut temats /cart/add-anrop mot bundlen när 3-månadersplanen är vald
  function xhrAdd(payload) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', root() + 'cart/add.js');
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      x.onload = function () { resolve(new Response(x.responseText, { status: x.status, headers: { 'Content-Type': 'application/json' } })); };
      x.onerror = function () { reject(new TypeError('Network error')); };
      x.send(JSON.stringify(payload));
    });
  }
  window.__bkmBundlePayloads = [];
  function arm() {
    var prev = window.fetch, done = false;
    var once = function (input, init) {
      var url = typeof input === 'string' ? input : (input && (input.href || input.url)) || '';
      if (!done && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        done = true; restore();
        var payload = { items: [{ id: Number(cfg.variantId), quantity: 1, selling_plan: Number(cfg.sellingPlanId) }] };
        window.__bkmBundlePayloads.push(payload);
        log('cart/add ersatt med bundle', JSON.stringify(payload));
        return xhrAdd(payload);
      }
      return prev.apply(this, arguments);
    };
    function restore() { if (window.fetch === once) window.fetch = prev; }
    window.fetch = once;
    setTimeout(function () { done = true; restore(); }, 1500);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest && t.closest('[data-add-to-cart], button[name="add"], [type="submit"][name="add"]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form || productForms().indexOf(form) === -1) return;
    var plan = selectedPlan(form);
    log('klick', 'plan=', plan, 'redo=', state.ready);
    if (!state.ready || fromPlans.indexOf(plan) === -1) return;
    arm();
  }, true);
  log('installerad för', product.handle, cfg);
})();
